export default (tableName) => ({
    endOfPage: false,

    init() {
        this.$nextTick(() => {
            const tableContainer = document.getElementById('table-container-'+tableName);

            this.setEndOfPage();

            tableContainer.style.overflowX = 'auto';
            tableContainer.style.scrollbarWidth = 'none';
            tableContainer.style.msOverflowStyle = 'none';

            const style = document.getElementById('scrollbar-style'+tableName) ?? document.createElement('style');
            style.id = 'scrollbar-style'+tableName;
            style.innerHTML = `
                #${tableContainer.id}::-webkit-scrollbar {
                    display: none;
                }
            `;
            document.head.appendChild(style);

            this._scrollListener = () => this.setEndOfPage();
            window.addEventListener('scroll', this._scrollListener);
        })
    },

    destroy() {
        if (this._scrollListener) window.removeEventListener('scroll', this._scrollListener);
    },

    async goToPage(page, pageName = null) {
        await this.$wire.call('gotoPage', page, pageName);

        this.setEndOfPage();
    },

    async nextPage(pageName) {
        await this.$wire.call('nextPage', pageName);

        this.setEndOfPage();
    },

    async previousPage(pageName) {
        await this.$wire.call('previousPage', pageName);

        this.setEndOfPage();
    },

    checkScrollIfScrollIsAtBottom() {
        const scrollTop    = window.scrollY;
        const innerHeight  = window.innerHeight;
        const scrollHeight = document.documentElement.scrollHeight;

        return (scrollHeight - (scrollTop + innerHeight)) < 20;
    },

    setEndOfPage() {
        this.endOfPage = this.checkScrollIfScrollIsAtBottom();
    },
});
